import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgProjectsBlue = (_a) => {
  var _b = _a, { size, title = "ProjectsBlue" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M35.25 21.75c0-5.376-5.72-9.75-12.75-9.75S9.75 16.374 9.75 21.75s5.72 9.75 12.75 9.75c.84 0 1.658-.066 2.453-.185l6.212 3.105a.744.744 0 00.73-.032.752.752 0 00.355-.638v-5.73c1.869-1.697 3-3.883 3-6.27z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M16.5 1.5C7.815 1.5.75 7.22.75 14.25c0 2.702 1.036 5.279 3 7.47v7.53a.752.752 0 001.085.671l6.998-3.498c1.526.383 3.094.577 4.667.577 8.685 0 15.75-5.72 15.75-12.75S25.185 1.5 16.5 1.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#3C6ED7",
    d: "M24.29 15.673l-5.615 4.078-4.13-5.577a3.363 3.363 0 014.653-4.779c.372.276.682.625.912 1.027a3.365 3.365 0 114.18 5.248v.003z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "white",
    d: "M9.77 8.91l.615 7.448-1.017.155L7.735 9.22l2.034-.31zm.678 11.276a1.35 1.35 0 10-.407-2.67 1.35 1.35 0 00.407 2.67z"
  }));
};
var ProjectsBlue = withIcon(SvgProjectsBlue);

export { ProjectsBlue as default };
//# sourceMappingURL=ProjectsBlue.es.js.map
